<template>
  <div>
    <!-- card one -->
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>New Goods Receipt</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/goods-receipt">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row dense id="po">
          <v-col cols="3">
            <v-autocomplete autocomplete="off" dense outlined v-model="record.CardCode" :items="suppliers"
              label="Supplier" item-text="Name" item-value="id" :search-input.sync="searchSuppliers">
              <template v-if="enableCreate" v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn class="ma-2" color="accent" dark small elevation="0" @click="openCreate()">
                    <v-icon left>mdi-plus</v-icon>Create A Supplier
                  </v-btn>
                </v-row>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="3">
            <v-text-field autocomplete="off" type="text" v-model="record.RefNo" outlined dense
              label="Reference No"></v-text-field>
          </v-col>

          <v-col cols="3">
            <DatePicker v-if="canBackDate == 'Y'" @date="setDate" :myDate="record.DocDate" :title="`Date`"
              ref="dateRef">
            </DatePicker>
            <span v-else class="style-16">Date: {{ date }}</span>
          </v-col>

          <v-col cols="3">
            <span class="style-24-accent">{{ storeName }}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- card two -->
    <v-card class="mt-4">
      <v-card-text>
        <v-row>
          <v-col cols="12" id="docForm">
            <!-- <v-alert
          v-if="orderItems.length == 0 && docCreate == true"
          type="warning"
          >You have not added any Item.</v-alert
            >-->

            <v-data-table light dense :items-per-page="pageItems" :headers="headers" :items="orderItems"
              item-key="o_i_t_m_s_id" hide-default-footer @item-selected="selectedRow" v-model="selectedItems"
              disable-sort>
              <template v-slot:item.num="{ item, index }">
                <span>{{ index + 1 }}</span>
              </template>

              <template v-slot:item.ItemCode="{ item }">
                <span v-if="IsDistributor == 'Y'">{{ item.ItemCode }}</span>
              </template>

              <template v-slot:item.Name="{ item }">
                <!-- autocomplete -->
                <v-text-field style="width: 400px" class="orderInput" single-line dense readonly
                  v-model="item.Name"></v-text-field>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <v-text-field autocomplete="off" type="number" name="goodsReceiptQuantity"
                  :filled="docCreate == false ? true : false" :readonly="docCreate == false ? true : false"
                  class="orderInput" @input="inputChanged(item)" single-line outlined dense
                  v-model="item.Quantity"></v-text-field>
              </template>

              <template v-slot:item.TaxId="{ item }">
                <v-autocomplete autocomplete="off" dense outlined single-line v-model="item.TaxId" :items="taxGroups"
                  label="Tax" item-text="Name" item-value="id" @change="inputChanged(item)"></v-autocomplete>
              </template>

              <template v-slot:item.UomEntry="{ item }">
                <v-text-field autocomplete="off" type="text" name="goodsReceiptUom" filled outlined readonly dense
                  value="Unit(s)" v-if="item.ManualStatus == 'Y'"></v-text-field>
                <v-autocomplete autocomplete="off" v-else dense outlined single-line v-model="item.UomEntry"
                  :items="item.ugp1" label="UOM" item-text="UomName" item-value="UomId" @change="uomChanged(item)">
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.UomName }} - ( {{ item.BaseQty }} )</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </template>

              <template v-slot:item.Price="{ item }">
                <v-text-field autocomplete="off" type="number" :filled="docCreate == false ? true : false"
                  :readonly="docCreate == false ? true : false" class="orderInput" @input="inputChanged(item)"
                  single-line outlined dense v-model="item.Price"></v-text-field>
              </template>

              <template v-slot:item.DisplayTotal="{ item }">
                <v-text-field class="orderInput" single-line outlined dense filled readonly
                  v-model="item.DisplayTotal"></v-text-field>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>

            <!-- <v-btn
          v-show="docCreate == true"
          @click="addRow"
          small
          color="primary"
          class="mt-1"
        >
          <v-icon left>mdi-plus</v-icon>Add Row
            </v-btn>-->

            <v-autocomplete ref="productSearch" :filter="customFilter" style="width: 500px" autocomplete="off" v-model="select"
              :isloading="isLoading" :items="products" :search-input.sync="searchProducts"
              @change="setOrderItem(select)" @keyup="handleScanKeyup" item-text="Name" item-value="id" cache-items class="mt-2" flat
              label="Search Product" outlined dense>
              <template v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn :loading="searchingProduct" class="ma-2" color="accent" dark small elevation="0"
                    @click="productModal()">
                    <v-icon left>mdi-plus</v-icon>Create A Product
                  </v-btn>
                </v-row>

              </template>

              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.Name }}</v-list-item-title>
                  <v-list-item-subtitle v-show="canSeeStockBalance == 'Y'">
                    Available Qty: {{ data.item.AvailableQty }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mt-4 docForm">
      <v-card-text>
        <v-row>
          <v-col cols="8">
            <div style="font-weight: bold; font-size: 22px">Total: {{ totalDisplayAmount }}</div>

            <div class="mt-2" style="font-weight: semi-bold; font-size: 12px; color: blue">Record Supplier Payments
            </div>

            <v-data-table dense class="p-4" light :headers="paymentHeaders" :items="accounts" hide-default-footer>
              <template v-slot:item.Name="{ item }">
                <div style="font-size: 16px; width: 120px">{{ item.Name }}</div>
              </template>
              <template v-slot:item.SumApplied="{ item }">
                <v-text-field type="number" outlined v-model="item.SumApplied" style="width: 200px"></v-text-field>
              </template>
              <template v-slot:item.PaymentRemarks="{ item }">
                <v-text-field outlined v-model="item.PaymentRemarks" style="width: 250px"></v-text-field>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="4">
            <v-textarea rows="4" label="Memo" outlined dense v-model="memo"></v-textarea>

            <v-text-field class="mt-2" autocomplete="off" type="text" name="batchName" v-model="record.batchName"
              label="Batch Name" dense outlined></v-text-field>
          </v-col>
          <v-col cols="4">
            <div style="font-weight: bold; font-size: 22px">Total Paid: {{ mPaid }}</div>
          </v-col>

          <v-col cols="4">
            <div style="font-weight: bold; font-size: 22px">Balance: {{ displayMBalance }}</div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-row class="mt-2">
      <v-col cols="12">
        <v-btn class="float-right" v-if="docCreate == true" color="primary" @click="sendData"
          :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Receive Goods
        </v-btn>
      </v-col>
    </v-row>

    <!-- Supplier quick add dialog -->
    <v-dialog v-model="supplierDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Create A Supplier</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="supplierDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <supplier-editor :initial="supplierItem" @data="saveSupplier"></supplier-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- product quick add dialog -->
    <v-dialog v-model="productDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create A Product</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="productDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <product-editor :docCreate="true" :initial="productItem" @data="saveProduct"></product-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- Account quick add dialog -->
    <v-dialog v-model="accountDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="accountDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <account-editor :initial="accountItem" @data="saveAccount"></account-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </div>
</template>


<script>
import SupplierEditor from "@/components/subscriber/suppliers/_components/quick-editor.vue";
import ProductEditor from "@/components/subscriber/products/creation/_components/editor.vue";
import AccountEditor from "@/components/subscriber/accounts/_components/quick-editor.vue";
import { v4 as uuidv4 } from 'uuid';
export default {
  name: "NewGoodsReceipt",
  components: {
    SupplierEditor,
    ProductEditor,
    AccountEditor
  },
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    },
    copyStatus: {
      type: Boolean
    }
  },
  data: () => ({
    record: {},
    fromStore: {},
    glRecord: {},
    memo: null,
    batchName: "",
    select: "",
    selectDesc: "",
    smsRef: "",
    searchProducts: null,
    searchingProduct: false,
    productDialog: false,
    productItem: {},
    accountItem: {},
    loader: false,
    isLoading: false,
    enableCreate: true,
    supplierDialog: false,
    accountDialog: false,
    supplierItem: {},
    pageItems: 100,
    taxGroups: [],
    selectedProduct: null,
    SumApplied: null,
    paymentMode: null,
    selectedItems: [],
    accounts: [],
    activeRow: null,
    storeId: null,
    singleSelect: true,
    orderItems: [],
    suppliers: [],
    products: [],
    stores: [],
    searchSuppliers: null,
    drivers: [],
    clearDate: "",
    AccountsVersion: "N",
    date: new Date().toISOString().substr(0, 10),
    scanBuffer: "",
    scanTimeout: null,
    headers: [
      { text: "No.", value: "num" },
      { text: "Item Code", value: "ItemCode" },
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Purchase UOM", value: "UomEntry" },
      { text: "Price", value: "Price" },
      { text: "Tax", value: "TaxId" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" }
    ],
    paymentHeaders: [
      { text: "Account", value: "Name" },
      { text: "Amount", value: "SumApplied" },
      { text: "Ref/Code", value: "PaymentRemarks" }
    ]
  }),
  computed: {
    canSeeStockBalance() {
      return localStorage.getItem("canSeeStockBalance");
    },
    canBackDate() {
      return localStorage.getItem("canBackDate");
    },
    IsDistributor() {
      return localStorage.getItem("IsDistributor");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map(item => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mBalance() {
      let bill = 0;
      let paid = 0;
      bill = this.totalAmount;
      paid = this.mTotalPayments;
      const balance = bill - paid;
      return balance;
    },
    displayMBalance() {
      return this.mBalance.toLocaleString();
    },
    displayBalance() {
      let bal = 0;
      if (this.docCreate == true) {
        bal = this.balance.toLocaleString();
      } else {
        bal = this.record.Balance;
      }
      return bal;
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    },
    PaidSum() {
      let paid = 0;
      if (this.record.PaidSum) {
        paid = this.record.PaidSum.toLocaleString();
      }
      return paid;
    },
    mTotalPayments() {
      let total = 0;
      if (typeof this.accounts != "undefined" && this.accounts.length > 0) {
        return this.accounts
          .map(item => {
            let amount = 0;
            if (item.SumApplied) {
              amount = parseFloat(item.SumApplied);
            }

            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mPaid() {
      return this.mTotalPayments.toLocaleString();
    }
  },
  watch: {
    initial: {
      handler: "init",
      immediate: true
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
    searchSuppliers(val) {
      if (val && val !== this.select && this.querySuppliers(val)) {
        this.querySuppliers(val);
      }
    }
  },
  methods: {
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }
    },
    customFilter(item, queryText, itemText) {
      const words = queryText.toLowerCase().split(/\s+/)
      const text = itemText.toLowerCase()
      return words.every(word => text.includes(word))
    },
    querySelections(searchText) {
      // var customerId = 0;
      // if (this.IsDistributor == "Y") {
      //   customerId = this.glRecord.DefaultDistributorCustomer;
      // }

      console.log(" searching product", searchText);

      const self = this;
      const url = "/products/search";

      const data = {
        SearchText: searchText.toString(),
        // CustomerId: customerId
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              console.log(res.ResponseData, " database results ");
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            // this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(() => {
          self.$store.commit("btnLoader", false);
          // this.$refs.snackbar.show(err, "red");
        });
    },
    querySuppliers(searchText) {
      const self = this;
      const url = "/suppliers/search";
      const data = {
        searchText: searchText
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    openCreate() {
      this.supplierDialog = true;
    },
    productModal() {
      this.productDialog = true;
    },
    accountModal() {
      this.accountDialog = true;
    },
    quickAdd(account) {
      this.accounts = [...this.accounts, account];
      this.paymentMode = account.id;
      this.$refs.snackbar.show("Account Added Successully", "green");
    },
    saveAccount(data) {
      const url = "/accounts";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.quickAdd(res.ResponseData);
            self.loader = false;
            self.accountDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveProduct(data) {
      const url = "/products";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.productDialog = false;
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show("Product added Successfully", "green");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveSupplier(data) {
      var storeId = parseInt(this.activeStore);
      data.store_id = storeId;
      const url = "/suppliers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show("Supplier Added Successully", "green");
            self.supplierDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDate(date) {
      this.date = date;
    },
    addRow() {
      let initArray = [];
      const LineNum = new Date().getTime();

      const details = {
        LineNum: LineNum,
        Name: null,
        Quantity: null,
        Price: null,
        ref1: null,
        TaxId: this.taxGroups[0].id,
        LineTotal: 0,
        DiscSum: null,
        UomEntry: null,
        ManualStatus: null,
        ugp1: [],
        DisplayTotal: 0
      };
      initArray.push(details);
      this.orderItems = [...this.orderItems, ...initArray];
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    inputChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const Total = Price * Quantity;
      // add tax
      const tax = this.taxGroups.find(record => {
        return record.id === data.TaxId;
      });

      let taxAmount = 0;
      let taxRate = 0;
      if (tax) {
        taxRate = tax.Rate;
        taxAmount = (taxRate / 100) * Total;
      }

      const LineTotal = Total + taxAmount;
      // end
      const DisplayTotal = LineTotal.toLocaleString();
      // find item
      const currentItem = this.orderItems.find(record => {
        return record.LineNum === data.LineNum;
      });

      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }
      // end of find

      // update record
      currentItem.TaxRate = taxRate;
      currentItem.TaxAmount = taxAmount;
      currentItem.LineTotal = LineTotal;
      currentItem.DisplayTotal = DisplayTotal;
      this.orderItems[pos] = currentItem;
    },
    uomChanged(data) {
      console.log(data, " data");
      var uomEntry = data.UomEntry;
      var ugp1 = data.ugp1;

      var ugp1Record = ugp1.find(record => {
        return record.UomEntry === uomEntry;
      });

      var price = ugp1Record.BuyingPrice;
      var Quantity = 0;
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const total = price * Quantity;

      const currentItem = this.orderItems.find(record => {
        return record.LineNum === data.LineNum;
      });

      const pos = this.orderItems.indexOf(currentItem);
      if (pos === -1) {
        return;
      }

      currentItem.LineTotal = total;
      currentItem.Price = price;
      currentItem.DisplayTotal = total.toLocaleString();
      this.orderItems[pos] = currentItem;
    },
    setOrderItem(id) {
      const store_id = this.activeStore;
      const self = this;

       var url = `/product-inventory/${id}/${store_id}`;
      // fetch the product from database
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            // current item definition
            let currentItem = {};
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.UomEntry = product.PUoMEntry;
            currentItem.o_i_t_m_s_id = id;
            currentItem.ItemCode = product.ItemCode;
            currentItem.Name = product.Name;
            currentItem.store_id = store_id;
            const LineNum = new Date().getTime();
            currentItem.LineNum = LineNum;
            currentItem.DiscSum = null;
            // end

            let initArray = [];
            if (product.HasUom === 0) {
              // check if manual yes and assign
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.Price = buyingPrice;
              currentItem.LineTotal = 0;
              currentItem.DisplayTotal = 0;
              currentItem.UomEntry = 0;
              initArray.push(currentItem);
              this.orderItems = [...this.orderItems, ...initArray];
              this.select = null;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = product.ugp1;
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.PUoMEntry;
              });
              currentItem.ugp1 = product.ugp1;
              currentItem.Price = ugp1Record.BuyingPrice;
              currentItem.currentPrice = ugp1Record.BuyingPrice;
              currentItem.LineTotal = 0;
              currentItem.DisplayTotal = 0;

              // push to array
              initArray.push(currentItem);
              this.orderItems = [...this.orderItems, ...initArray];
              this.select = "";
              self.products = [];
              // end of push
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    generateUniqueId() {
      var subscriberId = localStorage.getItem("subscriber_id");
      var date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      var dateString = `${year}-${month}-${day}`;
      var uniqueId = `${uuidv4()}-${dateString}-${subscriberId}`;
      return uniqueId;
    },
    sendData() {
      const activeStoreId = this.activeStore;
      if (this.date == null || this.date == undefined) {
        this.$refs.snackbar.show("Please select Date!", "red");
        return;
      }

      if (this.orderItems.length <= 0) {
        this.$refs.snackbar.show("You must have at least one product", "red");
        return;
      }

      if (!this.record.CardCode) {
        this.$refs.snackbar.show("Please select supplier", "red");
        return;
      }

      // create unique id
      var uniqueId = this.generateUniqueId();
      // end of unique id

      // date handling
      var transactionDate = new Date().toISOString().substr(0, 10)

      if (this.canBackDate == "Y") {
        transactionDate = this.date;
      }

      const data = this.record;

      data.UniqueId = uniqueId;
      data.DocDate = transactionDate;
      data.TargetType = null;
      data.BaseType = null;
      data.BaseEntry = null;
      data.ObjType = 12;
      data.DocTotal = this.totalAmount;
      data.TotalPaid = this.mTotalPayments;
      data.Balance = this.mBalance;
      data.DocNum = this.record.DocNum;
      data.DeliveryNo = this.record.DeliveryNo;
      data.memo = this.memo;
      data.DiscSum = 0;
      data.BatchID = activeStoreId;
      data.StoreID = parseInt(activeStoreId);
      data.Balance = this.balance;

      // add order items
      var orderData = this.orderItems;
      var rows = [];
      for (const row of orderData) {
        var details = {
          productId: row.o_i_t_m_s_id,
          UomEntry: row.UomEntry,
          Quantity: parseFloat(row.Quantity),
          Price: parseFloat(row.Price),
          LineTotal: parseFloat(row.LineTotal),
          name: row.Name,
          storeId: parseInt(activeStoreId)
        };

        rows.push(details);
      }
      // end

      data.rows = rows;

      // set payments
      let payments = [];
      const accountsData = this.accounts;

      for (const account of accountsData) {
        if (account.SumApplied) {
          let details = {
            accountId: parseInt(account.id),
            Amount: parseFloat(account.SumApplied),
            RefNo: account.PaymentRemarks
          };

          payments.push(details);
        }
      }

      data.payments = payments;
      this.$store.commit("btnLoader", true);

      this.$emit("data", data);
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.clearDate = res.ResponseData.clearDate;
            self.AccountsVersion = res.ResponseData.AccountsVersion;
            self.smsRef = res.ResponseData.smsRef;
            if (res.ResponseData.DefaultStockStore) {
              if (self.docCreate) {
                self.record.DocDate = new Date().toISOString().substr(0, 10);
              }
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/12`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (self.docCreate == true) {
              self.record = {
                ...self.record,
                DocNum: res.ResponseData
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setTaxGroups() {
      // get taxes first
      const self = this;
      this.$store
        .dispatch("get", `/taxgroups/I`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.taxGroups = res.ResponseData;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // then set
    },
    glAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/gl-integration`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.glRecord = { ...res.ResponseData };
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    handleScanKeyup(event) {
      // Clear any existing timeout
      if (this.scanTimeout) {
        clearTimeout(this.scanTimeout);
      }

      // Only handle Enter key
      if (event.key === "Enter" && this.searchProducts) {
        const scannedValue = this.searchProducts.trim();

        // If input has 8+ characters, assume it's a barcode scan
        if (scannedValue.length >= 8) {
          console.log("Detected barcode scan:", scannedValue);
          event.preventDefault();
          this.searchByBarcode(scannedValue);
          this.searchProducts = null;
          this.select = "";
        }
      }
    },
    searchByBarcode(barcode) {
      const self = this;
      const url = `/products/search/by/barcode/${barcode}`;
      
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.setOrderItem(res.ResponseData.id);
            }
          } else {
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(() => {
          self.$refs.snackbar.show("Product not found", "red");
        });
    }
  },
  created() {
    //  this.setTaxGroups();
    Promise.all([
      this.getAccounts(),
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum(),
      this.glAccounts()
    ]);
  }
};
</script>

<style scoped>
/* .v-text-field__details {
  display: none !important;
} */

/* Hide number input spinner arrows */
::v-deep input[type="number"]::-webkit-outer-spin-button,
::v-deep input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>